import { Component, forwardRef } from '@angular/core';
import { UserActionBaseComponent } from '../userAction-base.component';
import { LoginService } from 'app/Services/login.service';
import { MacroService } from 'app/Services/CatalogManagement/macro.service';
import { Macro } from 'app/Model/ui/Macro';

@Component({
    selector: 'userAction-removeAllOrderDetails',
    templateUrl: './userAction-removeAllOrderDetails.component.html',
    providers: [
        { provide: UserActionBaseComponent, useExisting: forwardRef(() => UserActionRemoveAllOrderDetailsComponent) }
    ],
    standalone: false
})
export class UserActionRemoveAllOrderDetailsComponent extends UserActionBaseComponent {
  deleteAdditionalPackings: boolean = false;

  constructor(public loginService: LoginService, public macroService: MacroService) {
    super(loginService, macroService);
  }

  public getActionId(macro: Macro): string {
    return macro.name + '(' + (this.deleteAdditionalPackings ? 1 : 0) + ')';
  }

  public createParameterStringAsJsonString(): string {
    return JSON.stringify({
      deleteAdditionalPackings: this.deleteAdditionalPackings
    });
  }

  public parseParameter(parameter: string) {
    if (!parameter) return;
    try {
      const parsed = JSON.parse(parameter);
      this.deleteAdditionalPackings = parsed.deleteAdditionalPackings ?? false;
    } catch (error) {
      console.error('Invalid JSON string provided:', error);
    }
  }
}
